import React,{useEffect,useState} from 'react';
import { Grid,Box, Typography,Button} from '@mui/material';
import { Formik,Form } from 'formik';
import { useSelector } from 'react-redux';
import DyButton from '../../components/GlobalComponents/DyButton/DyButton';
import { addLicenseFace } from '../CompanyManagment/Interfaces/Interfaces';
import FormikControl from '../../components/FormikControls/FormikControl';
import {useGetTenants} from './Hooks/index'
// import SearchIcon from '@mui/icons-material/Search';
import DYToastMessage from '../../components/GlobalComponents/DyToastMessage/DYToastMessage';
// import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
// import {FormControl,InputLabel,Select,MenuItem,
    // TextField, IconButton } from '@mui/material';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useGetAllTenantUserCount,useTenantRegister,useAddLicense } from '../CompanyManagment/Hooks/index';
// import InputAdornment from '@mui/material/InputAdornment';

const AddLicense = ({onSuccesss,initialValue,editMode,onClose,setShowToastMessage,setAddStaffState}:any) => {

//   const{mutate:inviteUser,data:inviteUserData,isSuccess,isError}:any=AddLicense()
  const tenantId:string=useSelector((state:any)=>state.meetings.profileTenantId);
  // const userId:string=useSelector((state:any)=>state.loign.userInfo.userId);
  const [phoneNumber,setPhoneNumer]=useState<any>(null);
  const [showToastMessage1,setToastMessage1]=useState<boolean>(false)

  const LicenseInitialValues:addLicenseFace={
    ceoCode:'',
    phoneNumber:'',
    personCount:'',
    fromDate:'',
    toDate:'',
    Strategy:false,
    Bank:false,
    update:false,
    BAU:false
}
  const[addLicenseInitialValues,setAddLicenseInitialValues]=useState<addLicenseFace>(LicenseInitialValues)
  // const{data:tenantUserCountData,isLoading:teamOPloading}=useGetAllTenantUserCount();
  const{mutate:getTenants,isError,isSuccess,data:deleteData}=useGetTenants()
  const { data: addLicenseData, mutate: addLicense} = useAddLicense();
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  const initialSubmitForm = (data: any) => {
    addLicense({...data,tenantId:tenantId})
  }

  useEffect(() => {
 if (editMode && initialValue) {
  let{ceoCode,personCount,fromDate,toDate,phoneNumber}=initialValue;
  let initVal={
    ceoCode:ceoCode,
    phoneNumber:phoneNumber,
    personCount:personCount,
    fromDate:fromDate,
    toDate:toDate,
    Strategy:false,
    Bank:false,
    BAU:false,
    update:false
  }
  setAddLicenseInitialValues(initVal)
 }
   
  }, [initialValue])
  
  const initialGetTenants=()=>{
    let body={
     phoneNumber:phoneNumber
    }
    getTenants(body)
    }

    const handleClose=()=>{
      onClose((prev:any)=>false)
    }
    
    useEffect(() => {
      if (addLicenseData) {
        if (addLicenseData?.data.isSuccess) {
          // setSuccessAddObjective(isSuccess)
          setShowToastMessage(true);
          SetIsSuccess(true);
          SetTMessage(addLicenseData?.data.metaData.message);
          //onSuccess();
          onClose(false);
        } else {
          setToastMessage1(true);
          SetIsSuccess(false);
          SetTMessage(addLicenseData?.data.metaData.message);
          //setAddObjError(addLicenseData?.data);
        }
      }
    }, [addLicenseData]);


  return (
    <Grid container>
   <Grid  item xs={12}  >
   <Box width={'100%'} textAlign={'center'}   >
   </Box>
   </Grid>


   <Grid item xs={12}   >
   
   <Formik 
    enableReinitialize
    initialValues={addLicenseInitialValues}
    onSubmit={(data: any) => {
      initialSubmitForm(data)

    }}
  >
    {
      ({ values, setFieldValue, dirty, isValid, touched, errors, setFieldTouched }) =>
        <Form>
          <Grid container columnSpacing={1} sx={{bgcolor: 'background.paper',mx:'auto',borderRadius:3}}   >

          <Grid item xs={12} md={12} mx={'auto'} >
          <label className="flex items-center">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="update"
                            value="update"
                            id="update"
                            defaultChecked={true}
                            onChange={() =>
                              values?.update === 
                              true?
                              setFieldValue(
                                "update",
                                false
                              ):
                              setFieldValue(
                                "update",
                                true
                              )
                            }
                            checked={
                              values?.update === 
                              true
                            }
                          />
                          <span >آپدیت لایسنس فعلی ؟</span>
                        </label>
          </Grid>

            <Grid item xs={12} md={10} mx={'auto'} >
            <FormikControl
               control='textField'
                type='text'
                label='کد دعوت'
                name='ceoCode'
                fullWidth
                value={values?.ceoCode ||''}
              
              />
            </Grid>
            <Grid item xs={12} md={10} mx={'auto'} >
            <FormikControl
               control='textField'
                type='text'
                label='شماره تلفن'
                name='phoneNumber'
                fullWidth
                value={values?.phoneNumber ||''}
              
              />
            </Grid>
            <Grid item xs={12} md={10} mx={'auto'} >
              <FormikControl
                control='textField'
                type='text'
                label='تعداد نفرات'
                name='personCount'
                fullWidth
                value={values?.personCount ||''}
              />
            </Grid>
            
            <Grid item xs={12} md={10} mx={'auto'} >
              <FormikControl
                control="date"
                label='از تاریخ'
                name='fromDate'
                fullWidth
                value={values?.fromDate ||''}
              />
            </Grid>

            <Grid item xs={12}md={10}  mx={'auto'} >
              <FormikControl
                control="date"
                type='text'
                label='تا تاریخ'
                name='toDate'
                fullWidth
                value={values?.toDate ||''}
              />
            </Grid>

            <Grid item xs={12} md={12} >
                    <div className="h-11 w-full mr-4 gap-x-2 flex  items-center">
                    <span className="items-center"> افزودن قابلیت:</span>
                      <label className="flex gap-x-2 items-center w-1/6">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="BAU"
                            value="BAU"
                            id="BAU"
                            defaultChecked = {true}
                            onChange={() =>
                              values?.BAU ===
                              true ? setFieldValue(
                                "BAU",
                                false
                              ) : 
                              setFieldValue(
                                "BAU",
                                true
                              )
                            }
                            checked={
                              values?.BAU ===
                              true
                            }
                          />
                          <span className="text-xs">
                            BAU
                          </span>
                      </label>
                      <label className="flex gap-x-2 w-1/6 items-center">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="Bank"
                            value="Bank"
                            id="Bank"
                            defaultChecked={true}
                            onChange={() =>
                              values?.Bank === 
                              true?
                              setFieldValue(
                                "Bank",
                                false
                              ):
                              setFieldValue(
                                "Bank",
                                true
                              )
                            }
                            checked={
                              values?.Bank === 
                              true
                            }
                          />
                          <span className="text-xs">بانک</span>
                        </label>
                        <label className="flex gap-x-2 w-1/6 items-center">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="Strategy"
                            value="Strategy"
                            id="Strategy"
                            defaultChecked={true}
                            onChange={() =>
                              values?.Strategy === 
                              true?
                              setFieldValue(
                                "Strategy",
                                false
                              ):
                              setFieldValue(
                                "Strategy",
                                true
                              )
                            }
                            checked={
                              values?.Strategy === 
                              true
                            }
                          />
                          <span className="text-xs">هدف و استراتژی</span>
                        </label>
                      </div>
                    </Grid>


            <Grid item xs={12} mt={1}  >
              <Box px={1} columnGap={2} display={'flex'} justifyContent={'center'} flexDirection={'row-reverse'}  >
                <Box >
                  <DyButton
                    caption={'ذخیره'}
                    color={'#00387C'}
                    onClick={() => { }}
                    disbled={!dirty || !isValid}
                    variant={'contained'}
                    bgColor={'#00387C'}
                    type={'submit'}
                  />
                </Box>
                <Box>
                  <DyButton
                    caption={'انصراف'}
                    disbled={false}
                    variant={'outlined'}
                    onClick={handleClose}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Form>
    }
  </Formik>
   </Grid>
   {
      showToastMessage1 && <DYToastMessage
      isSuccess={isSucces}
      message={tMessage}
      setShow={setToastMessage1}
      show={showToastMessage1}
      />
    }
    </Grid>
  )
}

export default AddLicense